import React, { useEffect, useState } from "react";

const JackpotRoot = () => {

  const [jackpot, setJackpot] = useState(768745.5);
  const [digits, setDigits] = useState([]);

  
  const formatNumber = (num) => {
    const parts = num.toFixed(2).split(".");
    const main = parseInt(parts[0]).toLocaleString("en-US");
    const formatted = main + "." + parts[1];
    return formatted.split("").map((char) =>
      [",", ".", " "].includes(char) ? char : Number(char)
    );
  };

  
  useEffect(() => {
    const interval = setInterval(() => {
      setJackpot((prev) => prev + Math.random() * 100 + 25);
    }, 1500);
    return () => clearInterval(interval);
  }, []);

 
  useEffect(() => {
    setDigits(formatNumber(jackpot));
  }, [jackpot]);

  return (
    <div className="jackpot-container">
      <div className="jackpot-bg">
        <img className="jackpot-title" src="/icons/jackpot/jackpot-banner.png" alt="Jackpot" />
        <div className="jackpot-box">
          <div className="jackpot-num">
            <div className="jackpot-num-list">
              {digits.map((digit, i) =>
                digit === "," ? (
                  <div className="point" key={i}>
                    <span>,</span>
                  </div>
                ) : digit === "." ? (
                  <div className="point" key={i}>
                    <span>.</span>
                  </div>
                ) : (
                  <div className="scroll-num" key={i}>
                    <ul
                      className="animate-list"
                      style={{
                        transform: `translateY(-${digit * 0.56}rem)`,
                        transition: "transform 0.6s ease-in-out",
                      }}
                    >
                      
                      {[...Array(3)].map((_, loopIndex) =>
                        [...Array(10).keys()].map((n) => (
                          <li key={`${loopIndex}-${n}`} style={{ height: "0.56rem" }}>
                            {n}
                          </li>
                        ))
                      )}
                    </ul>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JackpotRoot;
